import { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { red } from "@mui/material/colors";
import { useSolicitudesFirmaStore } from "hooks/useSolicitudesFirmaStore";
import { Actore, Promovente } from "interfaces/solicitudFirma/solicitudFirmaInterface";
import ImageBackground from "assets/images/shared_firma.svg";
import { PartesDemanda } from "./components/partesDemanda";
import { PartesPromocion } from "./components/partesPromocion";
import { typeDataSOlicitudPromocion } from "helpers/_solicitudFirmaHelpers";

interface InterfaceFirmantes {
  actores: Actore[] | null;
  demandados: Actore[] | null;
  promoventes: Promovente[] | null;
}
export const RegistroSolicitudFirma = () => {
  const { solicitudFirma } = useSolicitudesFirmaStore();
  const [firmantes, setFirmantes] = useState<InterfaceFirmantes>({
    actores: null,
    demandados: null,
    promoventes: null,
  });

  const dataSolicitud = typeDataSOlicitudPromocion( solicitudFirma?.demanda ? "demanda" : "promocion" , solicitudFirma  )

  useEffect(() => {
    if (solicitudFirma?.demanda?.solicitud?.partes) {
      setFirmantes({
        actores: solicitudFirma?.demanda.solicitud.partes.actores,
        demandados: solicitudFirma?.demanda.solicitud.partes.demandados,
        promoventes: null,
      });
    } else if (solicitudFirma?.promocion?.solicitud?.promoventes) {
      setFirmantes({
        actores: null,
        demandados: null,
        promoventes: solicitudFirma?.promocion?.solicitud?.promoventes,
      });
    }
    // eslint-disable-next-line
  }, [solicitudFirma]);

  return (
    <Card
      className="w-full lg:w-[92%] xl:w mx-auto"
      sx={{
        borderRadius: "10px",
        paddingY: "24px",
        boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
      }}
    >
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
            1
          </Avatar>
        }
        title={
          solicitudFirma?.demanda
            ? "Registro de solicitud demanda"
            : "Registro de solicitud Promoción"
        }
      />
      <Divider />
      <CardContent sx={{ paddingY: "2%", paddingX: "2%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            {dataSolicitud.map(({ value, name, id }) => (
              <Box className="flex w-full justify-between mb-2" key={id}>
                <Typography variant="subtitle2">{name} :</Typography>
                <Typography variant="body2" className="max-w-sm	">
                  {value}
                </Typography>
              </Box>
            ))}
            <Divider className="pt-3 pb-6" />
            <Box className="flex w-full justify-center  mb-2">
              {firmantes?.actores?.length && firmantes?.demandados?.length ? (
                <PartesDemanda
                  actores={firmantes.actores}
                  demandados={firmantes.demandados}
                />
              ) : null}
              {firmantes?.promoventes?.length ? (
                <PartesPromocion promoventes={firmantes.promoventes} />
              ) : null}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            <Box className="flex items-center justify-center	 h-full">
              <img src={ImageBackground} alt="shared-firma" className="h-3/5" />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
